<!-- Top bar -->
<mat-toolbar class="topBar">

  <!-- Back to Home -->
  <button mat-icon-button
          class="example-icon"
          type="button"
          aria-label="Example icon-button with menu icon"
          matTooltip="Back to Home"
          matTooltipPosition="below"
          (click)="router.navigate(['menu'])">
    <mat-icon>
      arrow_back
    </mat-icon>
  </button>

  <span>Deliveries for {{user.userName}}</span>
</mat-toolbar>

@for (landing of landings; track landing.logbookId; let index = $index) {
    <div style="padding-left: 10px; padding-right: 10px; padding-top: 10px; font-size: 16px;">
        <mat-card matRipple (click)="onLandingClick(index)" style="padding: 16px">
            <div class="container" style="padding-left: 12px; padding-right: 12px;">
                <div class="row">
                    <div class="col-3">
                        <b>Logbook {{landing.logbookId.substring(17)}}</b>
                    </div>
                    <div class="col-8">
                        <b>Received: </b>{{landing.receivedDate | date:'HH:mm, EE, MMM.dd'}}
                        <span *ngIf="landing.submissionDate && landing.receivedDate != landing.submissionDate">
                            <br>
                            <b>Last Edits Received: </b>{{landing.submissionDate | date:'HH:mm, EE, MMM.dd'}}
                        </span>
                    </div>
                    <div class="col-1">
                        <mat-icon *ngIf="landing.logbookId != editedLogbookId">done</mat-icon>
                        <mat-icon *ngIf="landing.logbookId == editedLogbookId">error</mat-icon>
                    </div>
                </div>
            </div>
        </mat-card>
    </div>
    
}
